import { atomFamily } from "jotai/utils";

import { UnUploadedImage } from "components/PhotoUpload/types";

import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";
import { createPersistedAtom } from "./utils/createPersistedAtom";

const sessionInjuredPeoplePhotosAtom = atomFamily((sessionId: string) =>
  createPersistedAtom<UnUploadedImage[]>(`injuredPeoplePhotos-${sessionId}`, [])
);

export const injuredPeoplePhotosAtom = createDerivedSessionAtom<UnUploadedImage[]>(sessionInjuredPeoplePhotosAtom);
